import { PLAN_MAPS } from '@shared/constants/plans';
import { ROLE_MAPS } from '@shared/constants/roles';
import { hasPlanAccess } from '@shared/utils/roles/has-plan-access.helper';
import { hasRoleAccess } from '@shared/utils/roles/has-role-access.helper';

const AVAILABILITY_CHECKS: Record<string, () => boolean> = {
  analytics: () => hasPlanAccess(PLAN_MAPS.AI_DASHBOARD_AI_REPORT_ANALYTICS_VIEW).some(Boolean),
  contacts: () => hasRoleAccess(ROLE_MAPS.CONTACTS_CONTACTS_LIST).some(Boolean),
  power_dialer: () => hasPlanAccess(PLAN_MAPS.POWER_DIALER_POWER_CAMPAIGN_VIEW).some(Boolean),
  bulk_messaging: () => hasRoleAccess(ROLE_MAPS.BULK_MESSAGING_CAMPAIGNS_VIEW).some(Boolean),
  load_wallet: () => hasRoleAccess(ROLE_MAPS.SETTINGS_WALLET_VIEW).some(Boolean),
  invite_members: () => hasRoleAccess(ROLE_MAPS.SETTINGS_MEMBERS_LIST).some(Boolean),
  add_call_setting: () => hasRoleAccess(ROLE_MAPS.SETTINGS_CALL_FLOWS_VIEW).some(Boolean),
  add_payment_method: () => hasRoleAccess(ROLE_MAPS.SETTINGS_PAYMENT_METHOD_VIEW).some(Boolean),
};

export function isUserGuideKeyAvailable(key: string): boolean {
  return AVAILABILITY_CHECKS[key]?.() ?? true;
}
